import { Injectable, inject } from '@angular/core';
import { ISaga } from '../models/saga/saga.model';
import { ApiBaseService } from '@core/services/api-base.service';
import { Observable } from 'rxjs';
import { AppConstants } from '@core/constants';
import { String } from 'typescript-string-operations';

@Injectable({ providedIn: 'root' })
export class SagaApi {
  private apiService = inject(ApiBaseService);

  /** Deprecated */
  createSaga(saga: Partial<ISaga>): Observable<ISaga> {
    return this.apiService.postJson<ISaga>(AppConstants.API.TECHNICAL_ONBOARDING.CREATE, saga);
  }

  getSaga(guid: string): Observable<ISaga> {
    const apiUrl = String.Format(AppConstants.API.TECHNICAL_ONBOARDING.GET, guid);
    return this.apiService.getJson<ISaga>(apiUrl);
  }

  updateSaga(saga: ISaga) {
    const apiUrl = String.Format(AppConstants.API.TECHNICAL_ONBOARDING.UPDATE, saga.guid);
    return this.apiService.putJson<ISaga>(apiUrl, saga);
  }
}
